import { memo } from 'react';

import AirtableIcon from '@/assets/airtable-logo.svg?react';
import { merge } from '@/components';
import { Logo, LogoProps } from '@/components/core';

export type AirtableLogoProps = LogoProps;

const IAirtableLogo = ({ className, ...rest }: AirtableLogoProps) => {
  return (
    <Logo className={merge('rounded-lg border border-gray-200 bg-white', className)} {...rest}>
      <AirtableIcon className="size-5" />
    </Logo>
  );
};

export const AirtableLogo = memo(IAirtableLogo) as typeof IAirtableLogo;
